<template>
	<div>
    <div class="popup_high_right sms-prices-popup"
         :class="['level-'+level,{}]">
      <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            Pricing by country
	            </h3>
	            <span>* The prices are experimental and are set to be adjusted slightly in the near future.</span>
	            <span class="margin-t-5">* We will only charge you on successfully delivered SMS messages.</span>

	            <div class="layout-column flex">

		            <div class="layout-row margin-b-20">
			            <input-field class="flex margin-t-25" style="padding-left: 10px" placeholder="Search by country name"
			                         v-model="search" tabindex="0" small  :icon="require('@/assets/img/search_icon_gray.svg')"/>
		            </div>

		            <div class="layout-row margin-b-20">
			            <table class="tariffs-table">
				            <thead>
				            <tr>
					            <td>Country</td>
					            <td>Price per SMS</td>
					            <td>Price per 1,000 SMS</td>
				            </tr>
				            </thead>
				            <tbody>
				            <tr v-for="tariff in sortedTariffs" :key="tariff.code">
					            <td>{{tariff.country}}</td>
					            <td>${{parseFloat(tariff.tariff+'').toFixed(4)}}</td>
					            <td>${{parseFloat((tariff.tariff * 1000)+'').toFixed(2)}}</td>
				            </tr>
				            </tbody>
			            </table>
		            </div>
	            </div>

	            <div style="min-height: 10px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button label="Close" border @click="$emit('close')" />
	    </div>


    </div>

	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import numbers from "@/helpers/numbers";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import {mapGetters} from "vuex";
import TrackingCodeEntry from "@/views/funnels/funnel-plus/funnel/tracking_codes/tracking_code_entry";
import VRadio from "@/components/base/v-radio";
import VSwitch from "@/components/base/v-switch";
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

export default {
	name: "sms-prices-popup",
	mixins: [API],
	components: {
		VSwitch,
		VRadio,
		TrackingCodeEntry,
		QuickActionsBtn,
		BackBtn,
		PopupBackdrop,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			saving: false,
			loading: false,
			search: "",
			tariffs: [],
		}
	},
	computed:{
		sortedTariffs() {
			let s = (this.search || "").toLowerCase()

			return this.tariffs.filter(x=>{
				return x.country.toLowerCase().includes(s) || x.code.toLowerCase().includes(s);
			}).sort((a,b)=>{
				if (a.code==="US") return -1;
				if (b.code==="US") return 1;

				if (a.code==="CA") return -1;
				if (b.code==="CA") return 1;

				if (a.code==="GB") return -1;
				if (b.code==="GB") return 1;

				if (a.code==="AU") return -1;
				if (b.code==="AU") return 1;

				return a.country > b.country;
			})
		}
	},
	methods: {
		closePopup() {
			this.$emit('close')
		},
		//API
		async load() {
			try {
				this.loading = true;
				this.tariffs = [];

				this.tariffs = await this.api.sms.listCountryTariffs();
			} catch (e) {
				this.$error(e);
			} finally {
				this.loading = false;
			}
		},
	},
	created() {
		this.load();
	},
}
</script>
<style lang="scss" scoped>
.sms-prices-popup {
	padding: 0;
	.tariffs-table {
		border-collapse: collapse;
		border-spacing: 0;
		user-select: text;
		border: 1px solid $light-grey;
		border-radius: 3px;
		width: 100%;

		thead {
			tr td {
				border-bottom: 1px solid $light-grey;
				background: $light-silver;
				padding: 4px 6px;
				color: $dark-grey;
				font-weight: 500;
			}
		}
		tbody {
			tr td {
				padding: 5px 6px;
				//border-bottom: 1px solid $grey;
			}
			tr:nth-child(odd) {
				background: $light-silver;
			}
		}
	}
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	.my-editor {
		font-family: Courier, monospace;
		font-size: 14px;
		line-height: 1.5;
		padding: 5px;
		//height: 25%;
		border-radius: 4px;
		border: 1px solid #ececec;
		background-color: whitesmoke;
		&.focused {
			border: 1px solid $blue;
		}
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 3px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		svg {
			//color: #18d7ae;
			height: 18px;
			&.refund {
				color: $black;
			}
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
